import Message from './Message';

export type { MessageTheme } from './interface';
export type { MessageProps, MessageCssVars } from './Message';

export default Message;
